/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enable_This_ListInputs */

const en_enable_this_list = /** @type {(inputs: Enable_This_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable this list`)
};

const fr_enable_this_list = /** @type {(inputs: Enable_This_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer cette liste`)
};

const de_enable_this_list = /** @type {(inputs: Enable_This_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Liste aktivieren`)
};

const it_enable_this_list = /** @type {(inputs: Enable_This_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abilita questo elenco`)
};

const ru_enable_this_list = /** @type {(inputs: Enable_This_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить этот список`)
};

const es_enable_this_list = /** @type {(inputs: Enable_This_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitar esta lista`)
};

const zh_cn2_enable_this_list = /** @type {(inputs: Enable_This_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用此列表`)
};

const ja_enable_this_list = /** @type {(inputs: Enable_This_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このリストを有効にする`)
};

const hi_enable_this_list = /** @type {(inputs: Enable_This_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस सूची को सक्षम करें`)
};

const pt_pt2_enable_this_list = /** @type {(inputs: Enable_This_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ative esta lista`)
};

/**
* | output |
* | --- |
* | "Enable this list" |
*
* @param {Enable_This_ListInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const enable_this_list = /** @type {((inputs?: Enable_This_ListInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enable_This_ListInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_enable_this_list(inputs)
	if (locale === "de") return de_enable_this_list(inputs)
	if (locale === "it") return it_enable_this_list(inputs)
	if (locale === "ru") return ru_enable_this_list(inputs)
	if (locale === "es") return es_enable_this_list(inputs)
	if (locale === "zh-CN") return zh_cn2_enable_this_list(inputs)
	if (locale === "ja") return ja_enable_this_list(inputs)
	if (locale === "hi") return hi_enable_this_list(inputs)
	if (locale === "pt-PT") return pt_pt2_enable_this_list(inputs)
	return en_enable_this_list(inputs)
});